
<script>
import http from '@/service/http'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Receber',
  data () {
    return {
      list: [],
      filtro: {
        inicio: moment().format('DD/MM/YYYY'),
        termino: moment().format('DD/MM/YYYY'),
        conta: ''
      },
      show: {
        filtro: false
      },
      contas: [{}],
      saldoAnterior: 0
    }
  },
  mounted () {
    this.fecth()
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    async fecth () {
      const { data } = await http.get(`financeiro/extrato`)
      if (data != null) {
        this.list = data.rows.data
        this.filtro = data.filtro
        this.contas = data.contas
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
        $('select').material_select()
      }, 0)
    },
    async filtrar () {
      const { data } = await http.get(`financeiro/extrato?inicio=${this.filtro.inicio}&termino=${this.filtro.termino}&conta=${this.filtro.conta}`)
      if (data != null) {
        this.list = data.rows.data
        this.filtro = data.filtro
        this.contas = data.contas
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
        $('select').material_select()
      }, 0)
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['permissoes']),
    hasItens () {
      return this.list.length > 0
    }
  }
}
</script>

<template>
	<div>

    <div class="content">

      <div class="row">
        <div class="col s12">
          <h5>Financeiro :: Extrato <span v-show="!loading">{{ filtro.inicio }} a {{ filtro.termino }}</span></h5>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <router-view></router-view>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <button class="btn-floating waves-effect waves-light" @click.prevent="show.filtro = !show.filtro"><i class="material-icons">filter_list</i></button>
        </div>
      </div>

      <form @submit.prevent="filtrar">

        <div class="row" v-show="show.filtro">

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_inicio" type="date"  v-model="filtro.inicio" :data-value="filtro.inicio">
            <label for="icon_inicio" class="active">Início</label>
          </div>

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_termino" type="date" v-model="filtro.termino"
                   :data-value="filtro.termino">
            <label for="icon_termino" class="active">Término</label>
          </div>

          <div class="col s12 m4">
            <label for="filtro_conta">Conta Bancária</label>
            <select name="conta" id="filtro_conta" v-model="filtro.conta">
              <option v-for="conta in contas" :value="conta.id">{{ (conta.id) ? conta.conta : 'Todas' }}</option>
            </select>
          </div>

          <div class="input-field col s12 m4">
            <button class="waves-effect waves-light btn"><i class="material-icons left">filter_list</i> Filtrar</button>
            <label></label>
          </div>

        </div>

      </form>

      <div class="center-align" v-show="!hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>Conta</th>
                <th class="right-align">R$ Crédito</th>
                <th class="right-align">R$ Débito</th>
                <th class="right-align">R$ Saldo</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td></td>
                <td>Saldo anterior</td>
                <td class="right-align"></td>
                <td class="right-align"></td>
                <td class="right-align"></td>
                <td class="right-align">{{ saldoAnterior }}</td>
              </tr>
              <tr v-for="item in list">
                <td>{{ formatDate(item.data_pagamento) }}</td>
                <td>{{ item.descricao }} {{ (item.parcela !== '1/1') ? item.parcela : '' }}</td>
                <td>{{ item.conta.conta }}</td>
                <td class="right-align">{{ (item.tipo == 2) ? item.valor_pago : '' }}</td>
                <td class="right-align">{{ (item.tipo == 1) ? item.valor_pago : '' }}</td>
                <td class="right-align">{{ item.saldo }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/financeiro/extrato/index.vue